import { render, staticRenderFns } from "./EditKendaraan.vue?vue&type=template&id=3e4b17c9&"
import script from "./EditKendaraan.vue?vue&type=script&lang=js&"
export * from "./EditKendaraan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports